// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetGuaranteePaymentSetupResponse

export type WidgetGuaranteePaymentSetupApiResponse = {
	client_secret: string;
	amount: number;
	connectedAccount: string | null;
};

export type WidgetGuaranteePaymentSetup = {
	client_secret: string;
	amount: number;
	connectedAccount: string | null;
};

export function hydrateWidgetGuaranteePaymentSetup(data: WidgetGuaranteePaymentSetupApiResponse): WidgetGuaranteePaymentSetup {
	return { ...data };
}